export default "__VITE_ASSET__BaCSQpUd__"